import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

import { use_focus_trap } from "@/composables/use_focus_trap";
import { assert_not_null } from "@/utils";

// Props
type PropTypes = {
  click_outside_to_close?: boolean;
  include_closing_x?: boolean;
  size?: string;
  custom_width?: string;
  // TODO: Make this required when we think we labelled all of them
  aria_label?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
    click_outside_to_close: { type: Boolean, default: false },
    include_closing_x: { type: Boolean, default: true },
    size: { default: "large" },
    custom_width: null,
    aria_label: null
  },
  setup(__props: any, { emit }: { emit: ({
  close: [];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { click_outside_to_close: boolean, include_closing_x: boolean, size: string, custom_width?: string, aria_label?: string };



// Emits


const container = ref<HTMLElement | null>(null);

function get_container() {
  const element = container.value;
  assert_not_null(element);
  return element;
}

use_focus_trap(container, {
  // If no focusable elements in the modal, focus the modal itself.
  fallbackFocus: get_container,

  // Escape and outside clicks are handled above.
  escapeDeactivates: false,
  allowOutsideClick: true,
});

return { __sfc: true,props, emit, container, get_container }
}

})